import { AppFreshness } from "@2skies/frontend-shared";

interface Props {
  label: string;
  stale: boolean;
}

/** Shared brand footer — freshness in the left slot, brand line centred. */
export function DeltaTapeFooter({ label, stale }: Props): JSX.Element {
  return (
    <div className="brand-footer">
      <span className="brand-footer__left">
        <AppFreshness label={label} stale={stale} />
      </span>
      <span className="brand-footer__brand">DeltaTape · 2ndSkiesTrading.com</span>
    </div>
  );
}
